<app-simple-select [inline]="inline" [autoOpen]="autoOpen"
                   [multiple]="multiple"
                   translationPrefix="select.device_status"
                   [selectList]="selectList"
                   [(selectedItems)]="selectedItems"
                   (selectedItemsChange)="updateData()">
</app-simple-select>